// MUI Imports
import type { Theme } from '@mui/material';

const backdrop: Theme['components'] = {
  MuiBackdrop: {
    styleOverrides: {
      root: {
        '&:not(.MuiBackdrop-invisible)': {
          backgroundColor:
            'color-mix(in srgb, var(--mui-palette-primary-main) 50%, transparent)',
        },
      },
    },
  },
};

export { backdrop };
